import React, { useState } from "react";
import { motion } from "framer-motion";
import Packages from "../Packages";
import * as Yup from "yup";
export default function StepThree(props) {
  const { onInputChange, data } = props;
  props.stepRef.validateData = validateData;
  const [packages] = useState([
    {
      name: "Standard",
      price: "500",
      points: [
        "End of Year Team Building",
        "Certificate of Membership",
        "Networking",
        "Project Participation",
      ],
    },
    {
      name: "Premium",
      price: "4,500",
      points: [
        "End of Year Team Building",
        "Certificate of Membership",
        "Networking",
        "Project Participation",
        "Faniki Branded Merchandise",
      ],
    },
  ]);
  const [errors, setErrors] = useState([]);
  const stepOneSchema = {
    package: Yup.string().required().label("Package"),
  };
  const schema = Yup.object().shape(stepOneSchema);

  async function validateData() {
    const stepOneData = {
      package: data.package,
    };
    try {
      await schema.validate(stepOneData, {
        abortEarly: false,
      });
      return { ok: true };
    } catch (error) {
      const errorObject = {};
      error.inner.forEach((e) => {
        errorObject[e.path] = e.message;
      });
      setErrors(errorObject);
      return { ok: false };
    }
  }
  function handleClearError(property) {
    setErrors({ ...errors, [property]: "" });
  }
  function onSetActivePackage(value) {
    handleClearError("package");
    onInputChange("package", value);
  }
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
      <Packages
        packages={packages}
        activePackage={data.package}
        setActivePage={onSetActivePackage}
      />
      {errors.package ? (
        <small className="px-2 text-red-500 text-xs">{errors.package}</small>
      ) : null}
    </motion.div>
  );
}
